__turbopack_context__.v({
  "closeBtn": "index-module__Bi1NKG__closeBtn",
  "content": "index-module__Bi1NKG__content",
  "overlayContent": "index-module__Bi1NKG__overlayContent",
  "root": "index-module__Bi1NKG__root",
});
